// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";

interface FooterCopyrightTextStyle {
    text?: TypographyPresentationProps;
}

export const footerCopyrightTextStyle: FooterCopyrightTextStyle = {};
const styles = footerCopyrightTextStyle;
type Props = WidgetProps;

const FooterCopyrightText: React.FunctionComponent<Props> = (props: Props) => (
    <Typography {...styles.text} variant="p" data-test-selector="Footer_CopyrightText">
        {siteMessage("Custom_FooterCopyrightText", new Date().getFullYear().toString())}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: FooterCopyrightText,
    definition: {
        group: "Footer",
    },
};

export default widgetModule;
